module.exports = __webpack_public_path__ + "static/media/toyota-minus.18738f2d.svg";